import Grid from '@mui/material/Unstable_Grid2/Grid2'
import ProcuraMorador from './ProcuraMorador/ProcuraMorador'
import ImoveisEncontrados from './ImoveisEncontrados/ImoveisEncontrados'
import PessoasImovelList from './PessoasImovelList/PessoasImovelList'
import { VisitantesContext } from '../../../Providers/VisitantesContext/VisitantesContext'
import { useContext } from 'react'
import PessoasSelecionadas from './PessoasSelecionadas/PessoasSelecionadas'
import PessoasImovelCard from './PessoasImovelCard/PessoasImovelCard'
import ListaEntradas from '../../../Components/ListaEntradas/ListaEntradas'

const VisitadosTab = () => {
    const { modoExibicao, liberarMorador } = useContext(VisitantesContext)
    const { liberarAcessoVisitantes } = useContext(VisitantesContext)

    return (
        <Grid sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
            <ProcuraMorador/>
            { !liberarMorador && modoExibicao == 'card' &&
            <>
                <ImoveisEncontrados />
                <Grid component={'form'} sx={{
                    display: 'flex',
                    width: '100%',
                    height: '65%'
                }}>
                    <PessoasImovelCard />
                    <PessoasSelecionadas />
                </Grid>
            </>
            }

            {!liberarMorador && modoExibicao == 'list' &&
                <Grid container direction={'row'} sx={{
                    height: '93%',
                    width: '100%'
                }}>

                    <PessoasImovelList />
                    <PessoasSelecionadas/>
                </Grid>
            }

            { liberarMorador &&
            <>
                <ImoveisEncontrados />
                <Grid component={'form'} sx={{
                    display: 'flex',
                    width: '100%',
                    height: '65%'
                }}>

                    <Grid sx={{ width: '100%', height: '100%', overflow: 'auto', borderRight: '1px solid white' }}>
                        <Grid sx={{ width: '97%' }}>
                            <ListaEntradas
                                callbackAbrirPorta={liberarAcessoVisitantes}
                            />
                        </Grid>
                    </Grid>
                    <PessoasSelecionadas />
                </Grid>
            </>
            }
        </Grid>
    )
}

export default VisitadosTab
